ixModuleRouting("impactx.filebrowser", {
    "/filebrowser": {
        templateUrl: "modules/filebrowser/templates/filebrowserlist.html",
        controller: "FileBrowserListCtrl",
        controllerAs: "fileBrowserListCtrl",
        process: "FileBrowserView",
    },
    "/filebrowser/:path": {
        templateUrl: "modules/filebrowser/templates/filebrowserlist.html",
        controller: "FileBrowserListCtrl",
        controllerAs: "fileBrowserListCtrl",
        process: "FileBrowserView",
    },
});
